import { Dispatch, SetStateAction, useState } from "react"

import { ReactComponent as ArrowDown } from '../../../../assets/icons/arrow_down.svg'

import { IFilterModal, IFilterProps } from "pages/Historic/Historic"
import { Container } from "./_selectHistoricFilter"

interface ISelectedFilterProps {
  setShowFilterModal: Dispatch<SetStateAction<IFilterModal>>;
  className: string;
}

type filterType = 'services' | 'status' | 'date'

export const SelectHistoricFilter = ({
  setShowFilterModal,
  className,
}: ISelectedFilterProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState('Filtrar por...')

  const handleFilterQuery = (current: string, currentLabel: string) => {
    setShowFilterModal(prevState => {
      const newState = {...prevState};

      Object.keys(newState)
        .forEach(key => newState[key as filterType] = false)

      newState[current as filterType] = true

      return newState
    })

    setSelectedFilter(currentLabel)
  }

  return (
    <Container
      isOpen={isOpen}
      onMouseLeave={() => setIsOpen(false)}
      {...{className}}
    >
      <h1
        onClick={() => setIsOpen(!isOpen)}
        className="select-filter__label"
      >
        {selectedFilter}
        <ArrowDown className="select-filter__arrow-down" />
      </h1>
      <div className="select-filter__buttons-wrapper">
        <button
          className="select-filter__button"
          onClick={() => handleFilterQuery('date', 'Data')}
        >
          Data
        </button>
        <button
          className="select-filter__button"
          onClick={() => handleFilterQuery('services', 'Serviços')}
        >
          Serviço
        </button>
        <button
          className="select-filter__button"
          onClick={() => handleFilterQuery('status', 'Status')}
        >
          Status
        </button>
      </div>
    </Container>
  )
}
